import React from 'react';
import { TaskList } from '../../components/Tasks';

const Tasks = () => {
  return <TaskList />;
};

export default Tasks;


